import clsx from 'clsx';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { returnScoreLabel, isCalculating } from 'helper/assessmentFunctions';
import CalculatingLabel from 'components/scores/CalculatingLabel';

import TopPerformerLabel from '../../TopPerformerLabel';
import GradedByList from '../../GradedByList';

import styles from './styles';


const CardPerformanceBlock = ({ candidate, gradeableCard, classes, isEmployerSortEnabled, className, showOverallRank = true }) => {
    const {
        rank, rankTotal, score, topPerformer,
        gradedBy, candidateId, scoreExists, archived, completed
    } = candidate;

    if (archived) return null;

    let overallScore = null;

    if (score) {
        const { score: newOverallScore } = score;
        overallScore = newOverallScore;
    }

    const renderedScoreLabel = returnScoreLabel(score, candidate, isEmployerSortEnabled);

    const renderScore = () => {
        if (!gradeableCard && isCalculating(candidate, (isEmployerSortEnabled && scoreExists) || !isEmployerSortEnabled)) {
            return (
                <>
                    <div className={classes.label}>
                        {renderedScoreLabel}
                    </div>
                    <CalculatingLabel
                        className="u-mrg--bx1 u-txt--12 u-txt--semibold"
                        fontSize={12}
                    />
                </>
            );
        }
        if (overallScore !== null) {
            return (
                <>
                    <div className={classes.label}>
                        {renderedScoreLabel}
                    </div>
                    <div className="u-dsp--f u-ai--center u-mrg--bx2">
                        <div className={classes.scoreLabel}>
                            {overallScore}%&nbsp;
                        </div>
                        <GradedByList
                            gradedBy={gradedBy}
                            candidateId={candidateId}
                        />
                    </div>
                </>
            );
        }
        return (
            <>
                <div className={clsx(classes.label, 'u-mrg--bx0')}>Score</div>
                <div className={classes.rankLabel}>-</div>
            </>
        );
    };

    return (
        <div className={clsx(classes.container, className, 'performance-block')}>
            <Typography variant="h4" className="u-mrg--bx1">Performance</Typography>
            {
                completed ? (
                    <>
                        {renderScore()}
                        {
                            !gradeableCard && showOverallRank && (
                                <>
                                    <div className={classes.label}>Overall Rank</div>
                                    <div className={classes.rankLabel}>
                                        {rank || '-'} / {rankTotal || '-'}
                                        {topPerformer && <TopPerformerLabel />}
                                    </div>
                                </>
                            )
                        }
                    </>
                ) : (<span className={classes.empty}>-</span>)
            }

        </div>
    );
};

export default withRouter(withStyles(styles)(CardPerformanceBlock));
